import useCurrentSpace from '@/modules/spacesSetting/hooks/useCurrentSpace';
import { renderUserSpace } from '@/modules/admin/components/UserSpace';
import {useLocation} from 'react-router-dom';
import {useMemo} from 'react';

export const useColumns = (columns) => {
  const {data: space} = useCurrentSpace();
  const {pathname} = useLocation();

  return useMemo(() => {
    const newColumns = [...columns];
    newColumns.splice(2, 0, {
      key: 'space',
      title: 'user_space',
      dataIndex: 'space',
      render: renderUserSpace
    });

    return space?.isRootSpace && pathname === '/admin/users' ?
      newColumns
      : columns;
  }, [space, columns, pathname]);
};
